import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrame = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5413_13877)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6 4V16",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 4V16",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 6L16.0001 6",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 14L16.0001 14",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5413_13877",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgFrame;
